import React from 'react';

import Spinner from 'react-spinner-material';
import { NewGraphBar } from '../../../utils/newGraphsBar';
import styles from './styles.module.scss';

export default function Recorrencias({
  recorrenciaPjSse,
  recorrenciaPjSas,
  recorrenciaPjMeiSas,
  recorrenciaPjMeSas,
  recorrenciaPjEppSas,

  isLoadingRecorrenciaPjSse,
  isLoadingRecorrenciaPjSas,
  isLoadingRecorrenciaPjMeiSas,
  isLoadingRecorrenciaPjMeSas,
  isLoadingRecorrenciaPjEppSas,
}) {
  const renderRecorrenciaPjSse = () => (
    <div
      className={
        isLoadingRecorrenciaPjSse ? styles.render_spinner_container : null
      }
    >
      {isLoadingRecorrenciaPjSse ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={recorrenciaPjSse?.mediaDiaria}
          total={
            recorrenciaPjSse?.média === 'NaN' ||
            recorrenciaPjSse?.média === undefined
              ? 0
              : recorrenciaPjSse?.média.toFixed(2)
          }
          label="recorrência PJ SSE"
          position="mes*média"
          subLabel="Registros por usuário (média)"
          axisY="média"
          date={recorrenciaPjSse?.data}
        />
      )}
    </div>
  );

  const renderRecorrenciaPjSas = () => (
    <div
      className={
        isLoadingRecorrenciaPjSas ? styles.render_spinner_container : null
      }
    >
      {isLoadingRecorrenciaPjSas ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={recorrenciaPjSas?.atendimentos}
          total={
            recorrenciaPjSas?.média === 'NaN' ||
            recorrenciaPjSas?.média === undefined
              ? 0
              : recorrenciaPjSas?.média.toFixed(2)
          }
          label="recorrência PJ SAS"
          position="mes*média"
          subLabel="Registros por usuário (média)"
          axisY="média"
          date={recorrenciaPjSas?.data}
        />
      )}
    </div>
  );
  const renderRecorrenciaPjMeiSas = () => (
    <div
      className={
        isLoadingRecorrenciaPjMeiSas ? styles.render_spinner_container : null
      }
    >
      {isLoadingRecorrenciaPjMeiSas ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={recorrenciaPjMeiSas?.atendimentos}
          total={
            recorrenciaPjMeiSas?.média === 'NaN' ||
            recorrenciaPjMeiSas?.média === undefined
              ? 0
              : recorrenciaPjMeiSas?.média.toFixed(2)
          }
          label="recorrência PJ MEI SAS"
          position="mes*média"
          subLabel="Registros por usuário (média)"
          axisY="média"
          date={recorrenciaPjMeiSas?.data}
        />
      )}
    </div>
  );
  const renderRecorrenciaPjMeSas = () => (
    <div
      className={
        isLoadingRecorrenciaPjMeSas ? styles.render_spinner_container : null
      }
    >
      {isLoadingRecorrenciaPjMeSas ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={recorrenciaPjMeSas?.atendimentos}
          total={
            recorrenciaPjMeSas?.média === 'NaN' ||
            recorrenciaPjMeSas?.média === undefined
              ? 0
              : recorrenciaPjMeSas?.média.toFixed(2)
          }
          label="recorrência PJ ME SAS"
          position="mes*média"
          subLabel="Registros por usuário (média)"
          axisY="média"
          date={recorrenciaPjMeSas?.data}
        />
      )}
    </div>
  );
  const renderRecorrenciaPjEppSas = () => (
    <div
      className={
        isLoadingRecorrenciaPjEppSas ? styles.render_spinner_container : null
      }
    >
      {isLoadingRecorrenciaPjEppSas ? (
        <div className={styles.spinner_style}>
          <Spinner radius={30} color={'#0061C6'} stroke={2} visible={true} />
        </div>
      ) : (
        <NewGraphBar
          dataGraphs={recorrenciaPjEppSas?.atendimentos}
          total={
            recorrenciaPjEppSas?.média === 'NaN' ||
            recorrenciaPjEppSas?.média === undefined
              ? 0
              : recorrenciaPjEppSas?.média.toFixed(2)
          }
          label="recorrência PJ EPP SAS"
          position="mes*média"
          subLabel="Registros por usuário (média)"
          axisY="média"
          date={recorrenciaPjEppSas?.data}
        />
      )}
    </div>
  );

  return (
    <div className={styles.central_container}>
      <div className={styles.render_big_container3}>
        <div className={styles.render_graph_container2}>
          {renderRecorrenciaPjSse()}
          {renderRecorrenciaPjSas()}
          {renderRecorrenciaPjMeiSas()}
          {renderRecorrenciaPjMeSas()}
          {renderRecorrenciaPjEppSas()}
        </div>
      </div>
    </div>
  );
}
